import { Sort, SubVertical } from 'common/constants'
import { axios } from 'common/utils'
import { BrandCard } from 'common/types/entities/brand'
import { Template } from 'common/types/entities/mongo/template'

const BASE_URL = '/v1/brands'

export const fetchBrandAndProductsList = async (subVertical: SubVertical, brandIds, productCount) => {
  const result = await axios.get<BrandCard[]>(`${BASE_URL}/${subVertical}/cards`, {
    params: { brandIds, productCount },
  })
  return result && result.data
}

export const fetchBrandById = async (subVertical: SubVertical, brandId, params) => {
  if (subVertical === SubVertical.ART) {
    const result = await axios.get<Template>(`${BASE_URL}/${subVertical}/${brandId}`, {
      params: { ...params },
    })
    return result && result.data
  }
}

export const isABCorREVERSE = sort => {
  return [Sort.ABC, Sort.ABC_REVERSE].includes(sort)
}
